import React from 'react';

const TimeRange = () => {
  const popularTimeRange = [
    { name: 'Morning (10-12pm)', timeRange: '10am - 12pm', minutes: 300 },
    { name: 'Afternoon (12-3pm)', timeRange: '12pm - 3pm', minutes: 280 },
    { name: 'Evening (3-6pm)', timeRange: '3pm - 6pm', minutes: 200 },
  ];

  const leastPopularTimeRange = [
    { name: 'Early Morning (8-10am)', timeRange: '8am - 10am', minutes: 50 },
    { name: 'Night (6-9pm)', timeRange: '6pm - 9pm', minutes: 60 },
  ];

  return (
    <div className="card">
      <h2>Popular & Least Popular Time of Day</h2>
      <div className="time-range">
        <div>
          <h3>Most Popular Times</h3>
          {popularTimeRange.map((time, index) => (
            <div key={index}>
              <p>{time.name}: {time.minutes} minutes</p>
            </div>
          ))}
        </div>
        <div>
          <h3>Least Popular Times</h3>
          {leastPopularTimeRange.map((time, index) => (
            <div key={index}>
              <p>{time.name}: {time.minutes} minutes</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TimeRange;
